import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M2 22h20V2z" />, 'SignalCellular4Bar');
